import FormControl from '@material-ui/core/FormControl';
import OutlinedInput  from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';
import styled from 'styled-components';
import {TextField} from '@material-ui/core';
import React from 'react';
import ProceduresContext from './ProceduresContext';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';


const Container = styled.div`
    padding-left:10px;
    width:300px;
`;

const useStyles = makeStyles((theme) => ({
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
        background:'white'
    },
    root: {
      height:37,
    }
  }));


const ProceduresSearch = () => {
    const classes = useStyles();

    const context = React.useContext(ProceduresContext);

   return <Container>
    <FormControl variant="outlined" fullWidth className={clsx(classes.margin, classes.textField, classes.root)}>
            <OutlinedInput className={clsx(classes.root)}
            placeholder="Search"
            id="adornment-password"
            type="text"
            value={context.searchText}
            onChange={event => context.setSearchText(event.target.value)}
            endAdornment={
                <InputAdornment position="end">
                <   Search/>
                </InputAdornment>
            }
            />
    </FormControl>
    </Container>
}

export default ProceduresSearch;